import { useState, useContext, useEffect, useRef } from 'react';
import { Box, Tabs, Tab, FormControl, Select, Skeleton, MenuItem, Stack, Typography } from '@mui/material';
import { List } from './List';
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { ToolContext } from '../../../../../../../../core/context/ToolContext';
import { rqx } from '../../../../../../../../core/request/API';
import { env } from '../../../../../../../../core/Env';
import { View as RealDataView} from './View';
// import { View as PreviewDataView} from '../../../../preview/list/view/Index'
import { View as PreviewDataView} from '../../../preview/list/view/Index'
import { ParsingAmount } from '../../../../../../../../core/validator/Validator';
// import { Waypoint } from "react-waypoint";
import { SnakeLoader } from '../../../../../../../../core/loader/SnakeLoader';

export const IndexList = ({ tLoader, td, templateForm, loadMoreProperties, company_id }) => {
    const { website_state } = useContext(ToolContext);
    const { provinceData, subTypes, inftScroll, hasMore, avlblePrprtyTypes } = website_state;
    const loaderRef = useRef(null);
    const nav = useHistory();
    const URLparams = new URLSearchParams(window.location.search);
    const view = URLparams.get("view");
    const menu = URLparams.get("menu");
    const propertyType = URLparams.get("property-type");
    const prop = propertyType === "condominium" ? 1: propertyType === "commercial" ? 2: propertyType === "apartment" ? 3 : propertyType === "house" ? 4 : propertyType === "land" ? 5 : 0;
    const [selectedLocation, setSelectedLocation] = useState(0);
    const [selectedSubType, setSelectedSubType] = useState(0);
    const tabLabels = [
        { label: 'All', url: 'all', id: 0 },
        { label: 'Condominium', url: 'condominium', id: 1 },
        { label: 'Commercial', url: 'commercial', id: 2 },
        { label: 'Apartment', url: 'apartment', id: 3 },
        { label: 'House', url: 'house', id: 4 },
        { label: 'Land', url: 'land', id: 5 },
    ];

    const handlePropertyTypeChange = (url) => {
        URLparams.set('property-type', url);
        nav.push(`${window.location.pathname}?${URLparams.toString()}`);
    }
    
    const getProvince = async () => {
        if (provinceData.data.value.length === 0) {
            const res_province = await rqx.get(`<<global>>/${env()}/location/province`, { ref: 'id', filter: 'all' });
            if ( res_province ) {
                provinceData.set({ ...provinceData.data, value: res_province })
            }
        }
    }

    const getSubType = async () => {
        let res = [];
        const ot_id = menu === 'property-rent' ? 2 : 1;
        if ( prop === 0 ) {
            res = await rqx.get(`<<shp>>/${env()}/website/listproperty`, { company_id: company_id, type: 'subtype', offer_type: ot_id });
        } else {
            res = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_subtype", filtered_id: prop });
        }
        if (res) {
            subTypes.set({ ...subTypes.data, value: res })
        }
    }
    
    useEffect(() => {
        getProvince();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        getSubType();
        setSelectedSubType(0);
        // eslint-disable-next-line
    }, [prop])

    const rndrPrice = (p, c) => {
        const { price, monthly, yearly } = typeof p === "string" ? JSON.parse(p) : p;
        const priceData = [
            { label: c === "view" ? "Price:" : "Price starts at:", value: Number(String(price).replace(/,/g, ""))/*price*/ },
            { label: "Monthly:", value: Number(String(monthly).replace(/,/g, ""))/*monthly*/ },
            { label: "Yearly:", value: Number(String(yearly).replace(/,/g, ""))/*yearly*/ },
        ];
        return priceData.filter((d) => d.value > 0).map((d, k) => (
            c === "view" ? 
                <Stack key={k} direction="row" alignItems="center" gap={1} mt="0.5rem">
                    <Typography fontSize="1.25rem" lineHeight="30px" fontWeight={600} color="#ff8c00" sx={{ minWidth: "3.2rem" }}>{d.label + " "}</Typography>
                    <Typography fontSize="1.25rem" lineHeight="30px" fontWeight={600} sx={{ color: "#ff8c00" }} >&#8369; {ParsingAmount(d.value)}</Typography>
                </Stack>
            :
                <Stack key={k} direction="row" alignItems="center" gap={1} mt={k === 1 ? "0.5rem" : "0rem"}>
                    <Typography fontSize={10} lineHeight="15px" fontWeight={500} sx={{ minWidth: "3.2rem" }}>{d.label + " "}</Typography>
                    <Typography fontSize="1rem" lineHeight="16px" sx={{ color: "#ff8c00" }} >&#8369; {ParsingAmount(d.value)}</Typography>
                </Stack>
        ));
    }

    const list = () => {
        let propertyList = [];
        const offerTypeId = menu === "property-rent" ? 2 : menu === "property-buy" && 1;
        if (offerTypeId && td.realListing) {
            const listing = td.realListing?.filter((list) => list.offer_type === offerTypeId);
            const filteredList = listing?.filter((property) => {
                const property_type = tabLabels?.find((v) => v.id === prop)
                const property_subtype = subTypes.data.value?.find((v) => v.id === selectedSubType)
                const matchesType = prop === 0 || property.property_type_name === property_type?.label;
                const matchesSubType = selectedSubType === 0 || property.property_subtype_name === property_subtype?.name;
                const matchesLocation = selectedLocation === 0 || property.province_id === selectedLocation;
                return matchesType && matchesSubType && matchesLocation;
            });
            propertyList = filteredList;
        }
        return propertyList;
    };
    // ANOTHER WAY OF USING WAYPOINT
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadMoreProperties(); // trigger when element is visible
                    }
                });
            },
            { threshold: 1.0 } // only trigger when 100% of the element is in view
        );
        const currentLoader = loaderRef.current;
        currentLoader && observer.observe(currentLoader);

        return () => {
            currentLoader && observer.unobserve(currentLoader);
        };

    }, [loadMoreProperties]);

    return (
        <Box width="100%" height="100%">
            { view === null ?  
            <>
                {!tLoader.data ? (
                    <Box width="100%" overflow="hidden" borderBottom="1px solid #ddd" position="relative" sx={{ height: '50px' }}>
                        { avlblePrprtyTypes.data.loader ? (
                            <Stack gap="0.5rem" p='1rem 2.5rem' flexDirection="row" sx={{ borderBottom: '1px solid #ddd' }}>     
                                <Skeleton variant="rounded" width={210} height={20} /> 
                                <Skeleton variant="rounded" width={210} height={20} /> 
                                <Skeleton variant="rounded" width={210} height={20} /> 
                            </Stack>
                        ) : (
                            <Tabs variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ alignItems: 'center', position: 'sticky', top: 0, left: 0, width: '100%', backgroundColor: 'white', '.MuiTabs-indicator': { display: 'none' }, }} value={prop} >
                                {/* {tabLabels.map((l, k) => (
                                    <Tab key={k} label={l.label} onClick={() => handlePropertyTypeChange(l.url)}
                                    sx={{
                                        fontSize: "0.75rem",
                                        fontWeight: "500",
                                        mx: "0.25rem",
                                        p: "0.2rem 0.4rem",
                                        minHeight: "fit-content",  
                                        border: `2px solid ${td.site_btns.bg}`,
                                        borderRadius: "8px",
                                        bgcolor: propertyType === l.url ? "#fff" : td.site_btns.bg,
                                        color: propertyType === l.url ? `${td.site_btns.bg} !important`: "#fff",
                                    }} />
                                ))} */}
                                {avlblePrprtyTypes.data.value?.map((v, i) => (
                                    <Tab key={i} label={v.name} onClick={() => handlePropertyTypeChange(v.url)}
                                    sx={{
                                        fontSize: "0.75rem",
                                        fontWeight: "500",
                                        mx: "0.25rem",
                                        p: "0.2rem 0.4rem",
                                        minHeight: "fit-content",  
                                        border: `2px solid ${td.site_btns.bg}`,
                                        borderRadius: "8px",
                                        bgcolor: propertyType === v.url ? "#fff" : td.site_btns.bg,
                                        color: propertyType === v.url ? `${td.site_btns.bg} !important`: "#fff",
                                    }} />
                                ))}
                            </Tabs>
                        )}
                    </Box>
                ) : <Skeleton variant='rounded' width="100%" height={40} />}
                <Box p="0.5rem 0.5rem 1.5rem" className="overflowY" height="68%">
                    {
                        !tLoader.data ?
                            <>
                                <FormControl size='small' fullWidth sx={{ mb: 1 }}>
                                    <Select
                                        value={selectedSubType}
                                        onChange={(e) => setSelectedSubType(e.target.value)}
                                    >
                                        <MenuItem value={0}>All Sub-Types</MenuItem>
                                        {subTypes.data.value.map((v, k) => (
                                            <MenuItem key={k} value={v.id}>{v.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size='small' fullWidth sx={{ mb: 1 }}>
                                    <Select
                                        value={selectedLocation}
                                        onChange={(e) => setSelectedLocation(e.target.value)}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: "15rem", maxWidth: "8rem" }, }, }} 
                                    >
                                        <MenuItem value={0}>All Locations</MenuItem>
                                        {provinceData.data.value.map((v, k) => (
                                            <MenuItem key={k} value={v.id}>{v.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        : 
                            <Skeleton variant='rounded' width="100%" height={40} sx={{ my: 1 }} />
                    }
                    <Box
                        display="grid"
                        gridTemplateColumns="repeat(auto-fit, minmax(180px, 1fr))"
                        gap={2}
                    >
                        {
                            !tLoader.data ? (
                                templateForm.data.status === 1 || templateForm.data.status === 2 ? (
                                    td.realListing === undefined ? (
                                        <>
                                            <Skeleton variant='rounded' width="100%" height={250} />
                                            <Skeleton variant='rounded' width="100%" height={250} />
                                        </>
                                    ) :
                                    list().length > 0 ? (
                                        <>
                                            {list().map((p, k) => (
                                                <Box key={k} width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
                                                    <List templateForm={templateForm} p={p} rndrPrice={rndrPrice}/>
                                                </Box>
                                            ))} 
                                        </> 
                                    ) 
                                    : (       
                                        <Typography textAlign="center" sx={{ mt: "2rem" }}>
                                            No properties available for {menu === "property-rent" ? "rent" : "buy"}
                                       </Typography>
                                    )
                                    // <Box> Hello! </Box>
                                ) : (
                                    td.staticList.map((p, k) => (
                                        <Box key={k} width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
                                            <List templateForm={templateForm} p={p} rndrPrice={rndrPrice}/>
                                        </Box>
                                    )) 
                                )
                            ) : (
                                <>
                                    <Skeleton variant='rounded' width="100%" height={250} />
                                    <Skeleton variant='rounded' width="100%" height={250} />
                                </>
                            )    
                        }
                        { !tLoader.data && (templateForm.data.status === 1 || templateForm.data.status === 2) && td.realListing !== undefined && inftScroll.data && hasMore.data && (
                            <Box ref={loaderRef} display="flex" justifyContent="center" my={2}>
                                <SnakeLoader bg={td.site_btns?.bg} size="10px" distance="5px" />
                            </Box>
                        )}
                    </Box>
                </Box> 
            </> 
            : 
                templateForm.data.status === 1 || templateForm.data.status === 2? 
                // <View rndrPrice={rndrPrice}/> 
                <RealDataView rndrPrice={rndrPrice} td={td}/>
                :
                <PreviewDataView viewId={window.atob(view)}/>
            }
        </Box>
    )
}